export const SET_LOADER = "SET_LOADER";
export const SET_ERROR = "SET_ERROR";

export const setLoader = data => ({
    type: SET_LOADER,
    payload: data
})

export const setError = data => ({
    type: SET_ERROR,
    payload: data
})

export default function reducer(state = { loading: false, isError: false }, { type, payload }) {
    switch (type) {
        case SET_LOADER:
            return {
                ...state,
                loading: payload
            };
        case SET_ERROR:
            return {
                ...state,
                isError: payload
            };
        default:
            return state
    }
}